import React from 'react'
import { useTranslation } from 'react-i18next'
import logoImgFr from './logo.png'
import logoImgAr from './logoArabe.png'

function LogoIcon(props) {
  const { i18n } = useTranslation()
  return  i18n.language === 'fr'
    ? <img src={logoImgFr} alt="Ndif logo" height="62px" {...props} />
    : <img 
        src={logoImgAr} 
        alt="Ndif logo" 
        style={{
          height: "64px",
          width: "145px",
          position: "relative",
          top: "5px",
          right: "3px"
        }} 
        {...props} 
      />
}

export default LogoIcon
